import { Service } from "models/Service";

const SHARE_IMAGE =
  "https://www.clarin.com/img/2026/09/11/9jCUBEnBL_2000x1500__1.jpg";

const PAGE_TITLE = "¿Cuánto vale mi propiedad?";
const PAGE_DESCRIPTION =
  "Conocé el valor estimado de tu casa o departamento según valores de referencia del mercado inmobiliario.";

export class Tasador extends Service {
  constructor() {
    super({
      adsPath: "servicios/home",
      meta: {
        description: PAGE_DESCRIPTION,
        keywords:
          "valor propiedad, tasador, precio casa, precio departamento, mercado inmobiliario, CABA",
        title: PAGE_TITLE,
        url: "propiedades/valor-propiedad",
        urlImage: SHARE_IMAGE,
        extra: [],
      },
      section: "propiedades",
      sectionAds: "valor-propiedad",
      template: "Tasador",
      title: PAGE_TITLE,
      titleHeader: "",
      slug: "propiedades",
      breadcrumb: [
        {
          title: "Propiedades",
          url: "/propiedades",
        },
        {
          title: "Valor de la propiedad",
          url: "",
        },
      ],
      widthFull: false,
      showLiveblog: false,
      showNewsToday: false,
      autorefresh: false,
      showTitleHeaderApp: false,
      showMenuApp: false,
      showBreadcrumbApp: true,
      showBannerH1App: false,
    });
  }

  parseData = async (match = []) => {
    // URL legacy: /tasador → /propiedades/valor-propiedad
    if (match?.[0] === "tasador") {
      this.setData({ redirect: "/propiedades/valor-propiedad" });
    }
  };
}
